import React, { useState } from "react";
import { fields } from "../../../utils/data";
import Form from "../../uiComponents/Form";
import { useDispatch } from "react-redux";
import { updateUser } from "../../../store/actions/user";

const initialValues = {
  name: "",
  email: "",
  phone: "",
  company: "",
  role: "",
};

const SignUp = ({ setLoader }) => {
  const [agree, setAgree] = useState(false);
  const dispatch = useDispatch();
  const handleSubmit = (values) => {
    dispatch(updateUser(values, setLoader));
  };
  const agreement = () => {
    setAgree((prevState) => !prevState);
  };
  return (
    <div className="sign-up">
      <h1>Create account</h1>
      <hr />
      <Form
        fields={fields}
        initValues={initialValues}
        submitValue="Create account"
        submitFunc={handleSubmit}
        agreement={agree}
      >
        <label className="checkbox checkbox-control">
            I agree to the&nbsp;
          <a
            href="https://bim-search.com/en/legals/"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Use
          </a>
            &nbsp; and the&nbsp; 
            <a
                href="https://bim-search.com/en/legals/"
                target="_blank"
                rel="noreferrer"
            >
                Privacy Statement
            </a>
          <input
            type="checkbox"
            name="agree"
            checked={agree}
            onChange={agreement}
          />
          <div className="checkbox-indicator"></div>
        </label>
      </Form>
    </div>
  );
};

export default SignUp;
